/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_TxtInputs */



/**
* | output |
* | --- |
* | "Text (.txt)" |
*
* @param {Text_TxtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_txt = /** @type {((inputs?: Text_TxtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_TxtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte (.txt)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text (.txt)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo (.txt)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст (.txt)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto (.txt)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本（.txt）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキスト（.txt）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट (.txt)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto (.txt)")
	return /** @type {LocalizedString} */ ("Text (.txt)")
});